<template>
  <div>
    <!-- //FILTRO -->
    <div class="row" v-if="!list">
      <div
        class="col-md-12 text-right"
        style="flex-wrap: wrap; margin-bottom: 10px"
      >
        <!-- <btn-rounded
            class="text-right"
            :label="'NOVO'"
            event="novo"
            :active-color="'success'"
          /> -->

        <btn-rounded
          class="text-right"
          :label="filter ? 'LIMPAR' : 'FILTRO'"
          event="showFilter"
          :active-color="filter ? 'danger' : 'primary'"
        />
      </div>

      <div v-if="filter">
        <div class="row" style="padding: 5px" text-center>
          <!-- <div class="col-md-3">
            <fg-select
              :options="materialList"
              v-model="filterOptions.MaterialId"
              :selected="filterOptions.MaterialId"
              label="Tipo de Material"
            />
          </div>
-->
          <div class="col-md-3">
            <fg-select
              :options="statusList"
              v-model="filterOptions.status"
              :selected="filterOptions.status"
              label="Status"
            />
          </div>

          <div class="col-md-9">
            <fg-input
              type="text"
              label="Busca"
              placeholder="Nome, Título, Número de Ordem, Código, Empresa..."
              v-model="filterOptions.term"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              type="date"
              label="Data de criação Inicial"
              :max="filterOptions.intervalEnd"
              v-model="filterOptions.intervalStart"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              type="date"
              label="Data de criação Final"
              :min="filterOptions.intervalStart"
              v-model="filterOptions.intervalEnd"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              type="text"
              class="clean"
              placeholder="Valor inicial"
              v-on:input="formatStart"
              label="Valor inicial"
              v-model="filterOptions.formattedvalueCentavosStart"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              type="text"
              class="clean"
              placeholder="Valor final"
              v-on:input="formatEnd"
              label="Valor final"
              v-model="filterOptions.formattedvalueCentavosEnd"
            />
          </div>
        </div>

        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-12" style="flex-wrap: wrap;">
            <div class="text-right">
              <btn-rounded
                class="text-right"
                label="FILTRAR"
                event="activeFilter"
                active-color="success"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FILTRO// -->

    <div class="row">
      <div class="col-md-12" style="margin-top: 10px">
        <component-table-pagination
          eventName="selectItem"
          PageEvent="changePage"
          :pageData="filterOptions.page"
          :limitData="filterOptions.limit"
          :print="true"
          :title="table.title"
          :sub-title="table.subTitle"
          :data="list || saleCarList"
          :columns="table.columns"
          :headers="table.headers"
        />
      </div>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import ComponentTablePagination from "components/UIComponents/Lists/ComponentTablePagination.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import moment from "moment";
const headers = [
  "Núm Ordem",
  "Carro",
  "Código",
  "Empresa",
  "Valor",
  "Cliente",
  "Status",
  "Data",
];
const tableColumns = [
  "orderNumber",
  "title",
  "code",
  "companyName",
  "formattedValueCentavos",
  "name",
  "status",
  "createdAt",
];
const control = [
  {
    event: "removeSaleCar",
    class: "ti-trash btn btn-danger btn-sm",
  },
];

export default {
  components: {
    ComponentTablePagination,
  },

  props: {
    list: {
      type: Array,
      default: () => {
        return null;
      },
    },
  },

  computed: {
    ...mapState({
      saleCarList: ({ car }) => car.list,
    }),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),
  },

  methods: {
    ...mapActions([
      "getCarList",
      "getSaleCarList",
      "deleteSaleCar",
      "getMaterialList",
    ]),

    setPage: function(page) {
      this.page = page;
    },

    cleanFilter() {
      let p = this.filterOptions.page;
      let l = this.filterOptions.limit;

      for (let idx in this.filterOptions) {
        this.filterOptions[idx] = undefined;
      }

      this.filterOptions.page = p;
      this.filterOptions.limit = l;

      // this.filterOptions.intervalStart = moment().startOf('month').format('YYYY-MM-DD');
      // this.filterOptions.intervalEnd = moment().endOf('month').format('YYYY-MM-DD');
      this.initData();
    },

    initData() {
      this.getSaleCarList(this.filterOptions);
    },

    formatStart: function(sValue) {
      this.filterOptions.formattedvalueCentavosStart = parseInt(
        ("" + sValue).onlyNumber()
      ).int2Money();

      this.filterOptions.valueCentavosStart = this.filterOptions.formattedvalueCentavosStart
        .replace("R$", "")
        .replace(",", "")
        .replace(".", "")
        .replace(" ", "");

      this.$nextTick(() => {});
    },

    formatEnd: function(sValue) {
      this.filterOptions.formattedvalueCentavosEnd = parseInt(
        ("" + sValue).onlyNumber()
      ).int2Money();

      this.filterOptions.valueCentavosEnd = this.filterOptions.formattedvalueCentavosEnd
        .replace("R$", "")
        .replace(",", "")
        .replace(".", "")
        .replace(" ", "");

      this.$nextTick(() => {});
    },
  },

  created() {
    this.cleanFilter();

    this.$on("novo", () => {
      this.$router.push("/admin/carro/criar");
    });
    this.$on("showFilter", () => {
      if (this.filter) this.cleanFilter();
      this.filter = !this.filter;
    });
    this.$on("activeFilter", () => {
      this.filterOptions.formattedvalueCentavosEnd = undefined;
      this.filterOptions.formattedvalueCentavosStart = undefined;

      if (
        this.filterOptions.valueCentavosStart >
        this.filterOptions.valueCentavosEnd
      ) {
        return this.$notify({
          group: "foo",
          title: "Busca invalida",
          text: "O valor inicial precisa ser menor do que o valor final.",
          position: "top center",
          type: "error",
        });
      }

      if (!!this.filterOptions.term && this.filterOptions.term.length < 3) {
        return this.$notify({
          group: "foo",
          title: "Busca invalida",
          text: "Minímo de 3 caracteres",
          position: "top center",
          type: "error",
        });
      }
      this.initData();
      this.filter = !this.filter;
    });

    this.$on("selectItem", (item) => {
      // this.$router.push({
      //   name: "Anúncios - Editar",
      //   params: {id: item}
      // });
    });

    this.$on("changePage", (item) => {
      console.log(item);
      this.filterOptions.page = item.page;
      this.filterOptions.limit = item.limit;
      // this.$cookies.set(window.location.href,this.filterOptions, 0);

      this.getSaleCarList(this.filterOptions);
    });

    this.$on("removeSaleCar", (item) => {
      this.$modal.show("dialog", {
        title: "Excluir Carro",
        text: "Tem certeza que deseja excluir esse carro?",
        buttons: [
          {
            title: "Sim",
            handler: () => {
              this.deleteSaleCar(item)
                .then((res) => {
                  this.$notify({
                    group: "foo",
                    title: "Sucesso",
                    text: res.msg,
                    position: "top center",
                    type: "success",
                  });
                  const index = this.saleCarList.indexOf(item, 0);
                  if (index > -1) {
                    this.saleCarList.splice(index, 1);
                  }
                })
                .catch((res) => {
                  this.$notify({
                    group: "foo",
                    title: res.msg,
                    text: res.info,
                    position: "top center",
                    type: "error",
                  });
                });

              this.$modal.hide("dialog");
            },
          },
          {
            title: "Não", // Button title
            handler: () => {
              this.$modal.hide("dialog");
            }, // Button click handler
          },
        ],
      });
    });
  },

  data() {
    return {
      chooseType: 0,
      table: {
        title: "Relação para Cobrança",
        subTitle: "Veículos adicionados, marcados, reservados e ofertados.",
        headers: [...headers],
        columns: [...tableColumns],
        control: [...control],
      },
      filter: false,
      filterOptions: {
        page: 0,
        limit: "10",
        isAdmin: undefined,
        idActive: undefined,
        term: undefined,
        intervalStart: undefined,
        intervalEnd: undefined,
        status: undefined,
        formattedvalueCentavosStart: undefined,
        formattedvalueCentavosEnd: undefined,
        valueCentavosStart: undefined,
        valueCentavosEnd: undefined,
      },
      statusList: [
        {
          name: "MARCADOS",
          value: 0,
        },
        {
          name: "RESERVADOS",
          value: 1,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/SaleCar/SaleCarList.vue